import React, { useEffect, useState } from 'react';
import LineGraph from './LineGraph';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import UserInputComponents from './UserInputComponents';
import { stateNameToAbbreviation } from '../utils/StateNameToAbbreviation';
import DisplayTopCards from './DisplayTopCards';
import DisplayDetailsTable from './DisplayDetailsTable';
import Header from './Header'
import axios from 'axios';
import Container from '@mui/material/Container';
import ErrorDialog from './ErrorDialog';
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DialogContentText from "@mui/material/DialogContentText";

function DashBoard() {

  var REACT_APP_API_URL = "https://fcc-api-multimonth2.costbroadband.net"
  //var REACT_APP_API_URL = "http://localhost:8000"
  //var REACT_APP_API_URL = "https://fcc-api-dev.costbroadband.net"
  var FW_CUTOFF = 10000
  var SAT_COST = 2223

  //'Jan 2024', 'Feb 2024 2024', 'Mar 2024', 'Apr 2024', 'May 2024', 'Jun 2024'
  const [monthValue, setMonthValue] = useState("12-2024")
  const [selectedState, setSelectedState] = useState("US");
  const [selectedData, setSelectedData] = useState("Dec 2024");
  const [inputTotal, setTotal] = useState(0);
  const [inputTotalFormat, setTotalFormat] = useState('');
  const [inputThreshold, setThreshold] = useState(0);
  const [inputThresholdFormat, setThresholdFormat] = useState('');
  const [inputFWSpend, setFWSpend] = useState(FW_CUTOFF);
  const [inputFWSpendFormat, setFWSpendFormat] = useState('');
  const [inputSatSpend, setSatSpend] = useState(SAT_COST);
  const [inputSatSpendFormat, setSatSpendFormat] = useState('');
  const [matchValue, setMatchValue] = useState(25);
  const [unusedValue, setUnusedValue] = useState(10);
  const [buriedValue, setburiedValue] = useState(10);
  const [data, setData] = useState();
  const [useOriginalThreshold, setUseOriginalThreshold] = useState(true);
  const [applyChanges, setApplyChanges] = useState(false);
  const [stateLoad, setStateLoad] = useState(false);
  const [applyOptimal, setApplyOptimal] = useState(false);
  const token = 'f671dc22966c0a52590babdd4ad276c8bfa023f6';
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);

  const InfoDialog = ({ open, onClose, selectedState }) => {
    const locationName = selectedState === 'PR' ? 'Puerto Rico' : 'the Virgin Islands';

    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Notification</DialogTitle>
        <DialogContent>
          <DialogContentText>
            All locations in {locationName} are covered by an enforceable commitment for the deployment of broadband. Therefore, all BEAD funding is available for connecting CAI and other deployment and non-deployment efforts.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  /*const state_defaults =  {
    'CA': {'buried': 90, 'match': 25, 'unused': 10},
    'AZ': {'buried': 50, 'match': 25, 'unused': 10},
    'CO': {'buried': 30, 'match': 25, 'unused': 10},
    'NY': {'buried': 64, 'match': 25, 'unused': 10},
    'OH': {'buried': 50, 'match': 25, 'unused': 10},
    'VT': {'buried': 5, 'match': 25, 'unused': 10},
  }*/

  const state_defaults = {
    'US': { 'buried': 66, 'match': 25, 'unused': 10 },
    'AL': { 'buried': 68, 'match': 25, 'unused': 10 },
    'AS': { 'buried': 2, 'match': 25, 'unused': 10 },
    'AK': { 'buried': 23, 'match': 25, 'unused': 10 },
    'AZ': { 'buried': 34, 'match': 25, 'unused': 10 },
    'AR': { 'buried': 53, 'match': 25, 'unused': 10 },
    'CA': { 'buried': 90, 'match': 25, 'unused': 10 },
    'CO': { 'buried': 48, 'match': 25, 'unused': 10 },
    'CT': { 'buried': 31, 'match': 25, 'unused': 10 },
    'DE': { 'buried': 14, 'match': 25, 'unused': 10 },
    'DC': { 'buried': 6, 'match': 25, 'unused': 10 },
    'FL': { 'buried': 88, 'match': 25, 'unused': 10 },
    'GA': { 'buried': 74, 'match': 25, 'unused': 10 },
    'GU': { 'buried': 8, 'match': 25, 'unused': 10 },
    'HI': { 'buried': 27, 'match': 25, 'unused': 10 },
    'ID': { 'buried': 25, 'match': 25, 'unused': 10 },
    'IL': { 'buried': 77, 'match': 25, 'unused': 10 },
    'IN': { 'buried': 45, 'match': 25, 'unused': 10 },
    'IA': { 'buried': 56, 'match': 25, 'unused': 10 },
    'KS': { 'buried': 42, 'match': 25, 'unused': 10 },
    'KY': { 'buried': 50, 'match': 25, 'unused': 10 },
    'LA': { 'buried': 84, 'match': 25, 'unused': 10 },
    'ME': { 'buried': 19, 'match': 25, 'unused': 10 },
    'MD': { 'buried': 63, 'match': 25, 'unused': 10 },
    'MA': { 'buried': 35, 'match': 25, 'unused': 10 },
    'MI': { 'buried': 55, 'match': 25, 'unused': 10 },
    'MN': { 'buried': 47, 'match': 25, 'unused': 10 },
    'MS': { 'buried': 64, 'match': 25, 'unused': 10 },
    'MO': { 'buried': 72, 'match': 25, 'unused': 10 },
    'MT': { 'buried': 21, 'match': 25, 'unused': 10 },
    'NE': { 'buried': 39, 'match': 25, 'unused': 10 },
    'NV': { 'buried': 51, 'match': 25, 'unused': 10 },
    'NH': { 'buried': 16, 'match': 25, 'unused': 10 },
    'NJ': { 'buried': 76, 'match': 25, 'unused': 10 },
    'NM': { 'buried': 26, 'match': 25, 'unused': 10 },
    'NY': { 'buried': 64, 'match': 25, 'unused': 10 },
    'NC': { 'buried': 82, 'match': 25, 'unused': 10 },
    'ND': { 'buried': 29, 'match': 25, 'unused': 10 },
    'MP': { 'buried': 3, 'match': 25, 'unused': 10 },
    'OH': { 'buried': 43, 'match': 25, 'unused': 10 },
    'OK': { 'buried': 59, 'match': 25, 'unused': 10 },
    'OR': { 'buried': 71, 'match': 25, 'unused': 10 },
    'PA': { 'buried': 63, 'match': 25, 'unused': 10 },
    'PR': { 'buried': 0, 'match': 0, 'unused': 100 },
    'RI': { 'buried': 11, 'match': 25, 'unused': 10 },
    'SC': { 'buried': 79, 'match': 25, 'unused': 10 },
    'SD': { 'buried': 32, 'match': 25, 'unused': 10 },
    'TN': { 'buried': 66, 'match': 25, 'unused': 10 },
    'TX': { 'buried': 87, 'match': 25, 'unused': 10 },
    'UT': { 'buried': 58, 'match': 25, 'unused': 10 },
    'VT': { 'buried': 5, 'match': 25, 'unused': 10 },
    'VA': { 'buried': 61, 'match': 25, 'unused': 10 },
    'VI': { 'buried': 0, 'match': 0, 'unused': 100 },
    'WA': { 'buried': 80, 'match': 25, 'unused': 10 },
    'WV': { 'buried': 18, 'match': 25, 'unused': 10 },
    'WI': { 'buried': 37, 'match': 25, 'unused': 10 },
    'WY': { 'buried': 13, 'match': 25, 'unused': 10 }


  }

  // Used for the initial loading of a state
  // before any user interaction
  useEffect(() => {
    // Check if the selected state is 'PR' or 'VI'
    if (selectedState === 'PR' || selectedState === 'VI') {
      setInfoDialogOpen(true);
    }
    else {
      // Close the dialog if open and set threshold for other states
      setInfoDialogOpen(false);
    }
    reLoadState();
  }, [selectedState]); // Add selectedState to the dependency array

  useEffect(() => {

    // Update unusedValue when data is received
    if (data && data.funds_for_non_deployment !== undefined) {
      setUnusedValue(data.funds_for_non_deployment);
    }

  }, [data]);
  const onTotalChange = (event) => {
    let formattedValue = event.target.value;
    formattedValue = formattedValue.replace(/\$/g, '');
    const numericValue = parseFloat(formattedValue.replace(/,/g, ''));
    setTotalFormat(numericValue);
    setApplyChanges(true);
    if (!isNaN(numericValue)) {
      setTotal(numericValue);
      if (useOriginalThreshold) {
        setApplyOptimal(true);
      }
      else {
        setApplyOptimal(false);
      }
    }
    else {
      setTotal(0);
    }
  };

  const onCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {

      setApplyOptimal(true);
      // Set FW and Sat back to default
      setFWSpend(FW_CUTOFF)
      setSatSpend(SAT_COST)
      setFWSpendFormat(Math.round(FW_CUTOFF).toLocaleString());
      setSatSpendFormat(Math.round(SAT_COST).toLocaleString());

    }
    else {
      setApplyOptimal(false);
    }
    setUseOriginalThreshold(isChecked);
    setApplyChanges(true);


  };

  const onApplyClick = () => {
    setStateLoad(true);
    if (applyOptimal === true) {
      onLoadOptimal();
    } else if (applyChanges === true) {
      onApplyChange();
    }
  };

  const onThresholdChange = (event) => {
    let formattedValue = event.target.value;

    if (isNaN(formattedValue)) {
      formattedValue = formattedValue.replace(/\$/g, '');
      formattedValue = parseFloat(formattedValue.replace(/,/g, ''));
    }
    setThresholdFormat(Math.round(formattedValue));
    setApplyChanges(true);
    if (!isNaN(formattedValue)) {
      setThreshold(formattedValue);
      if (useOriginalThreshold) {
        setApplyOptimal(true);
      }
      else {
        setApplyOptimal(false);
      }
    }
    else {
      setThreshold(0);
    }

  };

  const onFWSpendChange = (event) => {
    let formattedValue = event.target.value;

    if (isNaN(formattedValue)) {
      formattedValue = formattedValue.replace(/\$/g, '');
      formattedValue = parseFloat(formattedValue.replace(/,/g, ''));
    }
    setFWSpendFormat(Math.round(formattedValue));
    setApplyChanges(true);
    if (!isNaN(formattedValue)) {
      setFWSpend(formattedValue);
    }
    else {
      setFWSpend(0);
    }

  };

  const onSatSpendChange = (event) => {
    let formattedValue = event.target.value;

    if (isNaN(formattedValue)) {
      formattedValue = formattedValue.replace(/\$/g, '');
      formattedValue = parseFloat(formattedValue.replace(/,/g, ''));
    }
    setSatSpendFormat(Math.round(formattedValue));
    setApplyChanges(true);
    if (!isNaN(formattedValue)) {
      setSatSpend(formattedValue);
    }
    else {
      setSatSpend(0);
    }

  };



  const onUnusedChange = (event) => {
    let newUnused = event.target.value;
    newUnused = parseInt(newUnused);
    setApplyChanges(true);
    if (isNaN(newUnused)) {
      newUnused = 0;
    } else {
      newUnused = Math.min(100, Math.max(0, newUnused));
    }
    event.target.value = newUnused;

    setUnusedValue(newUnused);
    if (useOriginalThreshold) {
      setApplyOptimal(true);
    }
    else {
      setApplyOptimal(false);
    }
  };

  const onMatchChange = (event) => {
    const newMatch = event.target.value;
    setMatchValue(newMatch);
    setApplyChanges(true);
    if (useOriginalThreshold) {
      setApplyOptimal(true);
    }
    else {
      setApplyOptimal(false);
    }
  };

  const onFiberTypeChange = (event) => {
    const newBuried = event.target.value;
    setburiedValue(newBuried);
    setApplyChanges(true);
    if (useOriginalThreshold) {
      setApplyOptimal(true);
    }
    else {
      setApplyOptimal(false);
    }

  };


  // Used to call optimal threshold API after input API called
  const onLoadStart = async (funds_availible, selectedAbbreviation, match, unused, buried, mntval) => {
    console.log('onLoadStart')
    // #DJ stop double trigger


    if (!stateLoad) {

      console.log(funds_availible, selectedAbbreviation, mntval)
      if (funds_availible === undefined || selectedAbbreviation === undefined || mntval === undefined) {
        return;
      }

      const apiUrl = `${REACT_APP_API_URL}/optimal-threshold/${selectedAbbreviation}/${mntval}/${funds_availible}/${match}/${unused}/${buried}/`;
      //const apiUrl = `${REACT_APP_API_URL}/optimal-threshold/${selectedAbbreviation}/${funds_availible}/${match}/${unused}`;
      // console.log(apiUrl);
      try {
        setStateLoad(true);
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Token ${token}`,
          },
        });
        const data = response.data;

        setData(data);
        setThreshold(data.threshold);
        setThresholdFormat(Math.round(data.threshold).toLocaleString());
        setFWSpendFormat(Math.round(FW_CUTOFF).toLocaleString());
        setSatSpendFormat(Math.round(SAT_COST).toLocaleString());
        setTotalFormat(funds_availible.toLocaleString());
        console.log('Got to response from API')
        setStateLoad(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setStateLoad(false);
      }
    };
  }


  // Called when user changed the state in the drop down menu
  const onStateChange = async (event) => {

    if (!stateLoad) {

      const selectedFullName = event.target.value;
      const selectedAbbreviation = stateNameToAbbreviation[selectedFullName];
      setSelectedState(selectedAbbreviation);
      setUseOriginalThreshold(true)

      // console.log (selectedAbbreviation)
      if (selectedAbbreviation in state_defaults) {
        var defaultMatch = state_defaults[selectedAbbreviation]['match'];
        var defaultUnused = state_defaults[selectedAbbreviation]['unused'];
        var defaultBuried = state_defaults[selectedAbbreviation]['buried'];
      }
      else {
        defaultMatch = 25;
        defaultUnused = 10;
        defaultBuried = 10;
      }


      setMatchValue(defaultMatch);
      setUnusedValue(defaultUnused);
      setburiedValue(defaultBuried);


      const apiUrl = `${REACT_APP_API_URL}/input/${selectedAbbreviation}/${monthValue}/`;
      // console.log(apiUrl);

      try {
        setStateLoad(true);
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Token ${token}`,
          },
        });
        const data = response.data;
        setTotal(data.funds_availible);
        setStateLoad(false);
        await onLoadStart(data.funds_availible, selectedAbbreviation, defaultMatch, defaultUnused, defaultBuried, monthValue);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  }


    const onDataChange = async (event) => {

      if (!stateLoad) {
        console.log('ondataChange');
        const selectedFCCData = event.target.value;

        console.log(selectedFCCData);
        console.log(selectedState); // Note: This will still log the previous state.



        // Directly use `selectedState` for the API call since `setSelectedState` won't update immediately.
        const selectedAbbreviation = selectedState;

        // Update state as needed, but don't rely on it immediately after setting.
        setSelectedData(selectedFCCData);
        setUseOriginalThreshold(true);

        let mv = "12-2024"; // Default value
        if (selectedFCCData === "Jan 2024") {
          mv = "01-2024";
        } else if (selectedFCCData === "Feb 2024") {
          mv = "02-2024";
        } else if (selectedFCCData === "Mar 2024") {
          mv = "03-2024";
        } else if (selectedFCCData === "Apr 2024") {
          mv = "04-2024";
        } else if (selectedFCCData === "May 2024") {
          mv = "05-2024";
        } else if (selectedFCCData === "Jun 2024") {
          mv = "06-2024";
        } else if (selectedFCCData === "Aug 2024") {
          mv = "08-2024";
        } else if (selectedFCCData === "Dec 2024") {
          mv = "12-2024";
        }

        console.log(mv)
        setMonthValue(mv);

        let defaultMatch = 25, defaultUnused = 10, defaultBuried = 10; // Default values
        if (selectedAbbreviation in state_defaults) {
          defaultMatch = state_defaults[selectedAbbreviation]['match'];
          defaultUnused = state_defaults[selectedAbbreviation]['unused'];
          defaultBuried = state_defaults[selectedAbbreviation]['buried'];
        }

        setMatchValue(defaultMatch);
        setUnusedValue(defaultUnused);
        setburiedValue(defaultBuried);

        const apiUrl = `${REACT_APP_API_URL}/input/${selectedAbbreviation}/${mv}/`;
        console.log(apiUrl);

        try {
          setStateLoad(true);
          const response = await axios.get(apiUrl, {
            headers: {
              Authorization: `Token ${token}`,
            },
          });
          const data = response.data;
          setTotal(data.funds_availible);
          setStateLoad(false);
          await onLoadStart(data.funds_availible, selectedAbbreviation, defaultMatch, defaultUnused, defaultBuried, mv);
        } catch (error) {
          console.error('Error fetching data:', error);
          setStateLoad(false);
        }
      };
    }

      // Called if the user changes input fields but optimal
      // threshold is still checked
      const onLoadOptimal = async () => {

        if (!stateLoad) {

          //const apiUrl = `${REACT_APP_API_URL}/optimal-threshold/${selectedState}/${inputTotal}/${matchValue}/${unusedValue}`;
          const apiUrl = `${REACT_APP_API_URL}/optimal-threshold/${selectedState}/${monthValue}/${inputTotal}/${matchValue}/${unusedValue}/${buriedValue}/`;
          // console.log(apiUrl);
          try {
            setStateLoad(true);
            const response = await axios.get(apiUrl, {
              headers: {
                Authorization: `Token ${token}`,
              },
            });
            const data = response.data;
            setData(data);
            if (data.reached_underserved === false) {
              setErrorDialogOpen(true);
            }
            setThreshold(data.threshold);
            setThresholdFormat(Math.round(data.threshold).toLocaleString());
            setStateLoad(false);
            setTotalFormat(inputTotal.toLocaleString());
          } catch (error) {
            console.error('Error fetching data:', error);
            if (error.response && error.response.status === 400) {
              setErrorDialogOpen(true);
              reLoadState();

            }
            setStateLoad(false);
          }
          setApplyChanges(false);
        }
      };

      // Called when user changes fields and optimal threshold
      // is not checked
      const onApplyChange = async () => {
        if (!stateLoad) {
          console.log('onApplyChange', matchValue, inputThreshold)
          if (inputThreshold === undefined || inputTotal === undefined || selectedState === undefined
            || matchValue === undefined || unusedValue === undefined || buriedValue === undefined || monthValue === undefined || inputFWSpend === undefined || inputSatSpend === undefined) {
            return;
          }
          var inputThresholdI = Math.round(inputThreshold)
          //const apiUrl = `${REACT_APP_API_URL}/cost-model/${selectedState}/${inputTotal}/${inputThreshold}/${matchValue}/${unusedValue}`;
          console.log('FW Spend: ', inputFWSpend)
          const apiUrl = `${REACT_APP_API_URL}/cost-model/${selectedState}/${monthValue}/${inputTotal}/${inputThresholdI}/${matchValue}/${unusedValue}/${buriedValue}/${inputFWSpend}/${inputSatSpend}/`;
          // console.log(apiUrl);
          try {
            setStateLoad(true);
            const response = await axios.get(apiUrl, {
              headers: {
                Authorization: `Token ${token}`,
              },
            });
            
            const data = response.data;
            setData(data);
            if (data.reached_underserved === false) {
              setErrorDialogOpen(true);
            }
            setStateLoad(false);
            setTotalFormat(inputTotal.toLocaleString());
            setThresholdFormat(Math.round(inputThreshold).toLocaleString());
          } catch (error) {
            console.error('Error fetching data:', error);
            if (error.response && error.response.status === 400) {
              setErrorDialogOpen(true);
              reLoadState();
            }
            setStateLoad(false);
          }
          setApplyChanges(false);
        }
      }



      // Called after 400 errors to return state
      // to orginal values. 
      // Also used to initially load the first state.

      const reLoadState = async () => {
        if (!stateLoad) {

          const apiUrl = `${REACT_APP_API_URL}/input/${selectedState}/${monthValue}/`;
          // console.log(apiUrl);
          try {
            setStateLoad(true);
            const response = await axios.get(apiUrl, {
              headers: {
                Authorization: `Token ${token}`,
              },
            });
            setStateLoad(false);

            // console.log ('first state: ',selectedState)
            const data = response.data;
            setTotal(data.funds_availible);


            if (selectedState in state_defaults) {
              var defaultMatch = state_defaults[selectedState]['match'];
              var defaultUnused = state_defaults[selectedState]['unused'];
              var defaultBuried = state_defaults[selectedState]['buried'];
            }
            else {
              defaultMatch = 25;
              defaultUnused = 10;
              defaultBuried = 10;
            }

            setMatchValue(defaultMatch);
            setUnusedValue(defaultUnused);
            setburiedValue(defaultBuried);

            //setStateLoad(true);
            
            await onLoadStart(data.funds_availible, selectedState, defaultMatch, defaultUnused, defaultBuried, monthValue);
            //setStateLoad(false);
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
      }



      return (
        <div>
          <Header selectedState={selectedState} onStateChange={onStateChange} selectedData={selectedData} onDataChange={onDataChange} />
          <ErrorDialog open={errorDialogOpen} onClose={() => setErrorDialogOpen(false)} />
          <InfoDialog
            open={infoDialogOpen}
            onClose={() => setInfoDialogOpen(false)}
            selectedState={selectedState}
          />
          <DisplayTopCards data={data} match={matchValue} />

          <Container maxWidth="xl" style={{ display: 'flex', width: '1312px', justifyContent: 'center', alignItems: 'stretch' }}>

            <Grid container spacing={4} style={{ marginTop: '5px', alignItems: 'stretch', justifyContent: 'flex-start', height: '100%' }}>
              <Grid item xs={12} sm={8} style={{ display: 'flex', flexDirection: 'column' }}>
                <Paper elevation={8} style={{ flex: 1, height: '100%' }}>
                  <div style={{ padding: '20px' }}>
                    {selectedState !== 'PR' && selectedState !== 'VI' && (
                      <LineGraph stateLoad={stateLoad} data={data} selectedState={selectedState} />
                    )}
                  </div>
                </Paper>
              </Grid >



              <Grid item xs={12} sm={4} style={{ display: 'flex', flexDirection: 'column' }}>
                <UserInputComponents

                  selectedState={selectedState}
                  data={data}

                  onApplyClick={onApplyClick}
                  applyChanges={applyChanges}
                  onApplyChange={onApplyChange}

                  applyOptimal={applyOptimal}
                  onLoadOptimal={onLoadOptimal}

                  useOriginalThreshold={useOriginalThreshold}

                  onCheckboxChange={onCheckboxChange}
                  onMatchChange={onMatchChange}
                  onUnusedChange={onUnusedChange}
                  onStateChange={onStateChange}
                  onTotalChange={onTotalChange}
                  onFiberTypeChange={onFiberTypeChange}

                  buriedValue={buriedValue}
                  unusedValue={unusedValue}
                  matchValue={matchValue}

                  inputTotal={inputTotal}
                  inputTotalFormat={inputTotalFormat}

                  inputThreshold={inputThreshold}
                  inputThresholdFormat={inputThresholdFormat}
                  onThresholdChange={onThresholdChange}

                  inputFWSpend={inputFWSpend}
                  inputFWSpendFormat={inputFWSpendFormat}
                  onFWSpendChange={onFWSpendChange}

                  inputSatSpend={inputSatSpend}
                  inputSatSpendFormat={inputSatSpendFormat}
                  onSatSpendChange={onSatSpendChange}

                  style={{ flex: 1, justifyContent: 'space-between' }} />

              </Grid>

            </Grid>
          </Container>

          <DisplayDetailsTable data={data} />

        </div>
      );
    }
    export default DashBoard;